"use client";

import * as React from "react";
import Hide from "../../Hide";
const Desktop = ({
  children
}) => /*#__PURE__*/React.createElement(Hide, {
  on: ["smallMobile", "mediumMobile", "largeMobile", "tablet"]
}, children);
export default Desktop;